
import {
    APPLICATION_JSON,
} from '../constants/common.constant';

const defaultHeaders = {
    'Content-Type': APPLICATION_JSON,
    Accept: APPLICATION_JSON,
    Authorization: localStorage.getItem('token') ? localStorage.getItem('token') : ''
};

const request = async (endpoint, method, body, headers = defaultHeaders, absolutedEndpoint = false) => { // eslint-disable-line max-len
    let url = endpoint;
    if (!absolutedEndpoint) {
        url = process.env.REACT_APP_API_HOST + endpoint;
    }

    console.log("call: ", method, url, body, headers);

    let response;

    if (body != null) {
        let bodyJson = JSON.stringify(body);
        response = await fetch(url, {
            method,
            headers,
            body: bodyJson
        });
    } else {
        response = await fetch(url, {
            method,
            headers
        });
    }

    if (response.status < 200 || response.status >= 300) {
        throw new Error(response.statusText);
    }

    if (response.status === 200) {
        const json = await response.json();
        return json;
    } 
};

export const get = (endpoint, body, ...rest) => {
    const absolutedEndpoint = rest[rest.length - 1];
    let url = endpoint;
    if (body) {
        const paramsStr = Object.entries(body)
        .map(
            pair => pair.map(encodeURI).join('=')
        )
        .join('&');
        url = `${endpoint}?${paramsStr}`;
    }
    return request(url, 'GET', null, undefined, absolutedEndpoint || false);
};

export const post = (endpoint, body) => {
    return request(endpoint, 'POST', body);
}

export const put = (endpoint, body) => {
    return request(endpoint, 'PUT', body);
}

export default {
    get,
    post,
    put
};
